import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DownIcon from '../../../../../icons/arrow-down.svg';
import UpIcon from '../../../../../icons/arrow-up.svg';
import { NormalText } from '../../../StyledComponents';
import './CollapseButton.module.scss';

class CollapseButton extends React.PureComponent {
  render() {
    const {
      collapsed,
      onClick,
      isMobile,
      designSettings: {
        carrierMessagesTextColor: textColor,
        carrierMessagesIconColor: iconColor,
        carrierMessagesBackgroundColor: backgroundColor,
        bodyFontSize,
        bodyFont,
      },
      showHistoryLabel,
      hideHistoryLabel,
    } = this.props;

    const Icon = collapsed ? DownIcon : UpIcon;

    return (
      <button
        styleName={classNames('button', {
          mobile: isMobile,
          collapsed,
        })}
        onClick={onClick}
        aria-pressed={collapsed}
      >
        <div styleName="button-title">
          <NormalText type="bodyTertiary" isMobile={isMobile} fontSize={bodyFontSize} font={bodyFont} color={textColor}>
            {collapsed ? showHistoryLabel : hideHistoryLabel}
          </NormalText>
        </div>
        <div aria-hidden="true" styleName="button-icon" style={{ backgroundColor }}>
          <Icon styleName="icon" style={{ fill: iconColor }} />
        </div>
      </button>
    );
  }
}

CollapseButton.propTypes = {
  collapsed: PropTypes.bool,
  children: PropTypes.string,
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
  designSettings: PropTypes.shape({
    bodyFont: PropTypes.string,
    bodyFontSize: PropTypes.string,
    carrierMessagesTextColor: PropTypes.string,
    carrierMessagesIconColor: PropTypes.string,
    carrierMessagesBackgroundColor: PropTypes.string,
  }),
  showHistoryLabel: PropTypes.string,
  hideHistoryLabel: PropTypes.string,
};

export default CollapseButton;
